import { ELIGIBILITY_RESULTS_ACTION_TYPES } from '@constants/actionTypes/eligibilityResultsActionTypes';

export const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case ELIGIBILITY_RESULTS_ACTION_TYPES.SET_ELIGIBILITY_RESULTS: {
            return action.eligibilityResults;
        }
        case ELIGIBILITY_RESULTS_ACTION_TYPES.CLEAR_ELIGIBILITY_RESULTS: {
            return INITIAL_STATE;
        }
        default:
            return state;
    }
};